import { render, staticRenderFns } from "./CheckboxLarge.vue?vue&type=template&id=3d1074bc&"
import script from "./CheckboxLarge.vue?vue&type=script&lang=js&"
export * from "./CheckboxLarge.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxLarge.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports